document.addEventListener('DOMContentLoaded', function() {
  // Nutrition modal
  const nutritionTrigger = document.querySelector('[data-nutrition-trigger]');
  const nutritionModal = document.querySelector('[data-nutrition-modal]');

  if (nutritionTrigger && nutritionModal) {
    const closeEls = nutritionModal.querySelectorAll('[data-nutrition-close]');

    function openNutritionModal() {
      nutritionModal.classList.add('is-open');
      nutritionModal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeNutritionModal() {
      nutritionModal.classList.remove('is-open');
      nutritionModal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    nutritionTrigger.addEventListener('click', openNutritionModal);
    closeEls.forEach(el => el.addEventListener('click', closeNutritionModal));
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeNutritionModal(); });
  }

  // Accordion functionality
  const accordionItems = document.querySelectorAll('[data-accordion-item]');
  
  accordionItems.forEach(item => {
    const trigger = item.querySelector('[data-accordion-trigger]');
    const content = item.querySelector('[data-accordion-content]');
    
    if (!trigger || !content) return;
    
    trigger.addEventListener('click', function() {
      const isOpen = item.classList.contains('is-open');
      
      if (isOpen) {
        item.classList.remove('is-open');
        content.style.maxHeight = null;
      } else {
        item.classList.add('is-open');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });

  // Per-gallery thumbnail functionality
  function initGallery(galleryEl) {
    const thumbnailItems = galleryEl.querySelectorAll('[data-thumbnail-index]');
    const mainImages = galleryEl.querySelectorAll('[data-image-index]');
    const thumbnailContainer = galleryEl.querySelector('[data-thumbnail-container]');

    thumbnailItems.forEach(thumbnail => {
      thumbnail.addEventListener('click', function() {
        const index = this.getAttribute('data-thumbnail-index');

        thumbnailItems.forEach(item => item.classList.remove('active'));
        this.classList.add('active');

        mainImages.forEach(img => img.classList.remove('active'));
        const targetImage = galleryEl.querySelector(`[data-image-index="${index}"]`);
        if (targetImage) targetImage.classList.add('active');

        if (thumbnailContainer) {
          const scrollPosition = this.offsetLeft - (thumbnailContainer.offsetWidth / 2) + (this.offsetWidth / 2);
          thumbnailContainer.scrollTo({ left: scrollPosition, behavior: 'smooth' });
        }
      });
    });
  }

  document.querySelectorAll('[data-image-gallery]').forEach(initGallery);

  // Gallery switching state — initialised from the active tab button in the HTML
  const _initialBtn = document.querySelector('[data-category].active');
  let activeCategory = _initialBtn ? _initialBtn.getAttribute('data-category') : 'smoothies';
  let activeBoxSize = 'small';

  function switchGallery(key) {
    document.querySelectorAll('[data-image-gallery]').forEach(gallery => {
      const isTarget = gallery.getAttribute('data-image-gallery') === key;
      gallery.classList.toggle('active', isTarget);
      if (isTarget) {
        gallery.querySelectorAll('[data-image-index]').forEach((img, i) => img.classList.toggle('active', i === 0));
        gallery.querySelectorAll('[data-thumbnail-index]').forEach((t, i) => t.classList.toggle('active', i === 0));
        const tc = gallery.querySelector('[data-thumbnail-container]');
        if (tc) requestAnimationFrame(() => { tc.scrollLeft = 0; });
      }
    });
  }

  // Category switching functionality
  const categoryButtons = document.querySelectorAll('[data-category]');
  const subscriptionGroups = document.querySelectorAll('[data-subscription-group]');

  // Ensure only the active category group is visible on init
  subscriptionGroups.forEach(group => {
    group.style.display = group.getAttribute('data-subscription-group') === activeCategory ? 'block' : 'none';
  });

  categoryButtons.forEach(button => {
    button.addEventListener('click', function() {
      const category = this.getAttribute('data-category');
      
      categoryButtons.forEach(btn => btn.classList.remove('active'));
      this.classList.add('active');
      
      subscriptionGroups.forEach(group => {
        if (group.getAttribute('data-subscription-group') === category) {
          group.style.display = 'block';
        } else {
          group.style.display = 'none';
        }
      });

      activeCategory = category;
      const promoGalleryKey = this.getAttribute('data-promo-gallery');
      switchGallery(promoGalleryKey || `${activeCategory}-${activeBoxSize}`);
      updateCartButtonPrice();
    });
  });

  // Purchase type toggle (autoship vs one-time)
  const purchaseTypeOptions = document.querySelectorAll('[data-purchase-type-option]');
  
  purchaseTypeOptions.forEach(option => {
    const radio = option.querySelector('input[type="radio"]');
    const boxes = option.querySelector('[data-subscription-boxes], [data-onetime-boxes]');
    
    if (!radio) return;
    
    option.addEventListener('click', function() {
      if (!radio.checked) {
        radio.checked = true;
      }
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    });

    radio.addEventListener('change', function() {
      const parentGroup = this.closest('[data-subscription-group]');
      if (!parentGroup) return;
      
      const allOptions = parentGroup.querySelectorAll('[data-purchase-type-option]');
      
      allOptions.forEach(opt => {
        opt.classList.remove('active');
        const optBoxes = opt.querySelector('[data-subscription-boxes], [data-onetime-boxes]');
        if (optBoxes) {
          optBoxes.style.display = 'none';
        }
      });

      option.classList.add('active');

      if (boxes) {
        boxes.style.display = 'flex';
      }

      // Show benefits and update gallery for the active box within this option
      const activeBox = boxes
        ? (boxes.querySelector('[data-subscription-box].active') || boxes.querySelector('[data-subscription-box]'))
        : null;
      if (activeBox) {
        boxes.querySelectorAll('[data-subscription-box]').forEach(b => {
          const ben = b.querySelector('[data-benefits]');
          if (ben) ben.style.display = 'none';
        });
        const activeBenefits = activeBox.querySelector('[data-benefits]');
        if (activeBenefits) activeBenefits.style.display = 'flex';
        const activeRadio = activeBox.querySelector('input[type="radio"]');
        if (activeRadio) {
          activeBoxSize = activeRadio.value;
          switchGallery(`${activeCategory}-${activeBoxSize}`);
        }
      }

      updateCartButtonPrice();
    });
  });

  // Subscription box selection
  const subscriptionBoxes = document.querySelectorAll('[data-subscription-box]');

  function formatBoxPrice(cents) {
    const amount = parseInt(cents, 10);
    if (isNaN(amount)) return '';
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    return new Intl.NumberFormat(navigator.language || 'en-US', { style: 'currency', currency, minimumFractionDigits: 2 }).format(amount / 100);
  }

  function updateCartButtonPrice() {
    const activeGroup = document.querySelector(`[data-subscription-group="${activeCategory}"]`);
    if (!activeGroup) return;

    const button = activeGroup.querySelector('[data-add-to-cart]');
    if (!button) return;

    const activePurchaseOption = activeGroup.querySelector('[data-purchase-type-option].active');
    if (!activePurchaseOption) return;

    let activeBox = activePurchaseOption.querySelector('[data-subscription-box].active');
    if (!activeBox) activeBox = activePurchaseOption.querySelector('[data-subscription-box]');
    if (!activeBox) return;

    const price = activeBox.getAttribute('data-box-price');
    const formattedPrice = formatBoxPrice(price);

    const textEl = button.querySelector('.btn__text') || button;
    const baseText = button.getAttribute('data-base-text') || textEl.textContent.split('–')[0].trim();
    if (!button.hasAttribute('data-base-text')) button.setAttribute('data-base-text', baseText);

    const newText = formattedPrice ? `${baseText} – ${formattedPrice}` : baseText;
    textEl.textContent = newText;
  }

  subscriptionBoxes.forEach(box => {
    box.addEventListener('click', function() {
      const radio = this.querySelector('input[type="radio"]');
      if (!radio) return;

      const parentContainer = this.closest('[data-subscription-boxes], [data-onetime-boxes]');
      if (!parentContainer) return;

      const allBoxes = parentContainer.querySelectorAll('[data-subscription-box]');
      allBoxes.forEach(b => {
        b.classList.remove('active');
        const benefits = b.querySelector('[data-benefits]');
        if (benefits) {
          benefits.style.display = 'none';
        }
      });

      this.classList.add('active');
      radio.checked = true;

      activeBoxSize = radio.value; // "small" or "big"
      switchGallery(`${activeCategory}-${activeBoxSize}`);

      const benefits = this.querySelector('[data-benefits]');
      if (benefits) {
        benefits.style.display = 'flex';
      }

      const subscriptionBoxesContainer = this.closest('[data-subscription-boxes]');
      if (subscriptionBoxesContainer) {
        subscriptionBoxesContainer.querySelectorAll('[data-shared-benefits]').forEach(ben => {
          ben.style.display = ben.getAttribute('data-shared-benefits') === activeBoxSize ? 'flex' : 'none';
        });
      }

      updateCartButtonPrice();
    });
  });

  // Switch gallery to the initial active category
  if (_initialBtn) {
    const promoGalleryKey = _initialBtn.getAttribute('data-promo-gallery');
    switchGallery(promoGalleryKey || `${activeCategory}-${activeBoxSize}`);
  }

  updateCartButtonPrice();

  // ─── Cart UI refresh utility ───────────────────────────────────────────────
  async function refreshCartUI() {
    const parser = new DOMParser();
    var sectionBase = window.location.pathname.replace(/\/$/, '') || '';
    var cacheBust = '&_cb=' + Date.now();

    const [cartDrawerResponse, cartIconResponse] = await Promise.all([
      fetch(sectionBase + '?section_id=cart-drawer' + cacheBust, { cache: 'no-store' }),
      fetch(sectionBase + '?section_id=cart-icon-bubble' + cacheBust, { cache: 'no-store' })
    ]);

    const [cartDrawerHtml, cartIconHtml] = await Promise.all([
      cartDrawerResponse.text(),
      cartIconResponse.text()
    ]);

    const cartDrawerDoc = parser.parseFromString(cartDrawerHtml, 'text/html');
    const newCartDrawerSection = cartDrawerDoc.querySelector('.shopify-section');
    const cartDrawer = document.querySelector('cart-drawer');

    if (newCartDrawerSection && cartDrawer) {
      const newCartDrawerElement = newCartDrawerSection.querySelector('cart-drawer');
      if (newCartDrawerElement) {
        cartDrawer.innerHTML = newCartDrawerElement.innerHTML;
        cartDrawer.classList.remove('is-empty');
      }
    }

    const cartIconDoc = parser.parseFromString(cartIconHtml, 'text/html');
    const newCartIconContent = cartIconDoc.querySelector('body').innerHTML;
    const cartIconBubbleLink = document.querySelector('#cart-icon-bubble');

    if (cartIconBubbleLink && newCartIconContent) {
      const oldBubble = cartIconBubbleLink.querySelector('.cart-count-bubble');
      if (oldBubble) oldBubble.remove();

      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = newCartIconContent.trim();
      const newBubble = tempDiv.querySelector('.cart-count-bubble');
      if (newBubble) cartIconBubbleLink.appendChild(newBubble);
    }
  }

  // ─── Add to cart ──────────────────────────────────────────────────────────
  const addToCartButtons = document.querySelectorAll('[data-add-to-cart]');
  
  addToCartButtons.forEach(button => {
    button.addEventListener('click', async function(e) {
      e.preventDefault();
      
      const currentActiveGroup = this.closest('[data-subscription-group]')
        || document.querySelector('[data-subscription-group]:not([style*="display: none"])');
      // Simple products (no box/subscription UI) just submit the plain
      // /cart/add form they live in — add it over AJAX so the drawer opens
      // instead of leaving the click dead after the preventDefault above.
      if (!currentActiveGroup) {
        const simpleForm = this.closest('form[action*="/cart/add"]');
        if (!simpleForm) {
          console.error('No active subscription group');
          return;
        }

        const simpleTextEl = this.querySelector('.btn__text');
        if (simpleTextEl) simpleTextEl.style.opacity = '0.5';
        this.style.pointerEvents = 'none';
        this.disabled = true;

        try {
          const response = await fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
            method: 'POST',
            body: new FormData(simpleForm),
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          });

          if (!response.ok) {
            const errorData = await response.json();
            console.error('Error adding to cart:', errorData);
            alert(errorData.description || errorData.message || 'Error adding to cart. Please try again.');
            return;
          }

          await refreshCartUI();

          setTimeout(() => {
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) cartDrawer.open();
          }, 100);
        } catch (error) {
          console.error('Error adding to cart:', error);
          alert('Error adding to cart. Please try again.');
        } finally {
          if (simpleTextEl) simpleTextEl.style.opacity = '1';
          this.style.pointerEvents = 'auto';
          this.disabled = false;
        }
        return;
      }
      
      // Determine purchase type first, then scope activeBox to that section only
      const activePurchaseType = currentActiveGroup.querySelector('[data-purchase-type-option].active');
      const isSubscription = activePurchaseType && activePurchaseType.getAttribute('data-purchase-type-option') === 'subscription';

      const activeBox = activePurchaseType
        ? activePurchaseType.querySelector('[data-subscription-box].active')
        : currentActiveGroup.querySelector('[data-subscription-box].active');
      if (!activeBox) {
        console.error('No variant selected');
        return;
      }

      const itemsDataAttr = activeBox.getAttribute('data-items');
      const subItems = itemsDataAttr ? JSON.parse(itemsDataAttr) : [];

      if (subItems.length === 0) {
        console.error('No sub-products configured for this box');
        return;
      }

      const boxName = activeBox.getAttribute('data-box-name') || 'Box';
      const boxImage = activeBox.getAttribute('data-box-image') || '';
      const boxPrice = activeBox.getAttribute('data-box-price') || '';
      // Undiscounted box price (in cents) so the cart drawer can show it struck through
      const boxComparePrice = activeBox.getAttribute('data-box-compare-price') || '';
      // Box description ("28 smoothies • 4 weeks") — the cart drawer reads the frequency from it
      const boxDescription = activeBox.getAttribute('data-box-description') || '';

      let cartPayload;
      // Promo boxes carry a stable group id so re-adding merges into the same
      // cart line (quantity goes up) instead of creating a duplicate box.
      const stableGroupId = activeBox.getAttribute('data-box-group-id');
      const isLimitedQty = activeBox.getAttribute('data-promo-limited') === 'true';
      const boxGroupId = stableGroupId || `box-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

      // Boxes with a stable group id (promo) may already be in the cart.
      let existingGroupItems = [];
      if (stableGroupId) {
        try {
          const cartRes = await fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', { credentials: 'same-origin' });
          const liveCart = await cartRes.json();
          existingGroupItems = liveCart.items.filter(item => item.properties && item.properties['_box_group'] === boxGroupId);
        } catch (error) {
          console.error('Error checking cart for existing promo box:', error);
        }

        // Limited quantity: max 1 of this box in the cart — if it's already
        // there, just open the drawer instead of adding again.
        if (isLimitedQty && existingGroupItems.length > 0) {
          const limitMessage = activeBox.getAttribute('data-promo-limited-message')
            || "This offer is limited to 1 per order — it's already in your cart.";
          if (window.kenckoToast) {
            window.kenckoToast('info', boxName, limitMessage);
          }
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) cartDrawer.open();
          return;
        }
      }

      if (isSubscription) {
        // Subscription: add each product with its own selling plan (per-item selling plans from Smartrr)
        const missingSellingPlan = subItems.length === 0 || subItems.some(item => !item.selling_plan);

        if (missingSellingPlan) {
          console.error('Missing selling plan for one or more subscription items');
          alert('This subscription option is not properly configured. Please try again.');
          return;
        }

        cartPayload = {
          items: subItems.map(item => ({
            id: item.id,
            quantity: item.quantity,
            selling_plan: item.selling_plan,
            properties: {
              '_box_group': boxGroupId,
              '_box_name': boxName,
              '_box_image': boxImage,
              '_box_qty': item.quantity,
              ...(boxComparePrice ? { '_box_compare_price': boxComparePrice } : {}),
              ...(boxDescription ? { '_box_description': boxDescription } : {}),
              ...(isLimitedQty ? { '_limited': 'true' } : {})
            }
          }))
        };
      } else {
        // One-time: add individual products with a shared group key for cart display
        cartPayload = {
          items: subItems.map(item => ({
            ...item,
            properties: {
              '_box_group': boxGroupId,
              '_box_name': boxName,
              '_box_image': boxImage,
              '_box_price': boxPrice,
              ...(boxComparePrice ? { '_box_compare_price': boxComparePrice } : {}),
              '_box_qty': item.quantity,
              ...(isLimitedQty ? { '_limited': 'true' } : {})
            }
          }))
        };
      }

      const originalText = button.querySelector('.btn__text');
      if (originalText) originalText.style.opacity = '0.5';
      button.style.pointerEvents = 'none';
      button.disabled = true;

      try {
        // Already in the cart: bump the existing lines instead of adding again.
        // /cart/add rejects a second add when the product has a per-order
        // purchase limit ("The maximum quantity of this item is already in
        // your cart."), while /cart/update raises the quantity fine.
        if (existingGroupItems.length > 0) {
          const updates = {};
          existingGroupItems.forEach(item => {
            const baseQty = parseInt(item.properties['_box_qty'], 10) || item.quantity;
            updates[item.key] = item.quantity + baseQty;
          });

          const updateResponse = await fetch((window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update') + '.js', {
            method: 'POST',
            body: JSON.stringify({ updates }),
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            }
          });

          if (!updateResponse.ok) {
            const errorData = await updateResponse.json();
            console.error('Error updating box quantity:', errorData);
            alert(errorData.description || errorData.message || 'Error adding to cart. Please try again.');
            return;
          }

          await refreshCartUI();

          setTimeout(() => {
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) cartDrawer.open();
          }, 100);

          return;
        }

        const response = await fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST',
          body: JSON.stringify(cartPayload),
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        });
        
        if (!response.ok) {
          const errorData = await response.json();
          console.error('Error adding to cart:', errorData);
          alert(errorData.description || errorData.message || 'Error adding to cart. Please try again.');
          return;
        }
        
        await response.json();

        const variantSelector = document.querySelector('[data-variant-selector]');
        const offerVariantId = variantSelector && variantSelector.getAttribute('data-offer-variant');
        const offerVariant2Id = variantSelector && variantSelector.getAttribute('data-offer-variant-2');
        const offerVariant2Qty = parseInt((variantSelector && variantSelector.getAttribute('data-offer-variant-2-qty')) || '1', 10) || 1;
        const offerVariant2Start = variantSelector && variantSelector.getAttribute('data-offer-variant-2-start');
        const offerVariant2End = variantSelector && variantSelector.getAttribute('data-offer-variant-2-end');
        const now = new Date();
        const offer2InRange = (
          (!offerVariant2Start || now >= new Date(offerVariant2Start)) &&
          (!offerVariant2End || now <= new Date(offerVariant2End))
        );
        const customerHasOrders = variantSelector && variantSelector.getAttribute('data-customer-has-orders') === 'true';

        // Apply free bottle discount code only for new/guest customers on one-time purchases
        if (!isSubscription && !customerHasOrders) {
          await fetch('/discount/FREE-UNIVERSAL-BOTTLE', {
            method: 'GET',
            credentials: 'same-origin'
          });
        }

        // Add offer product if configured (skipped for promo one-time purchases)
        const skipOffer = this.hasAttribute('data-no-offer');
        if (offerVariantId && !skipOffer) {
          if (customerHasOrders) {
            // Returning customer: link offer to box group so cart drawer groups it visually
            await fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
              method: 'POST',
              body: JSON.stringify({ items: [{ id: parseInt(offerVariantId, 10), quantity: 1, properties: { '_offer_item': 'true', '_offer_for': boxGroupId } }] }),
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              }
            });
          } else {
            // New/guest customer: add offer inside the box as a hidden free item
            await fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
              method: 'POST',
              body: JSON.stringify({ items: [{ id: parseInt(offerVariantId, 10), quantity: 1, properties: { '_hidden': 'true', '_offer_for': boxGroupId } }] }),
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              }
            });
          }
        }

        // Add offer product 2 if configured and within the active date/time range
        if (offerVariant2Id && offer2InRange && !skipOffer) {
          if (customerHasOrders) {
            await fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
              method: 'POST',
              body: JSON.stringify({ items: [{ id: parseInt(offerVariant2Id, 10), quantity: offerVariant2Qty, properties: { '_offer_item': 'true', '_offer_for': boxGroupId, '_offer_2': 'true' } }] }),
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              }
            });
          } else {
            await fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
              method: 'POST',
              body: JSON.stringify({ items: [{ id: parseInt(offerVariant2Id, 10), quantity: offerVariant2Qty, properties: { '_hidden': 'true', '_offer_for': boxGroupId, '_offer_2': 'true' } }] }),
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              }
            });
          }
        }

        await refreshCartUI();

        setTimeout(() => {
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) cartDrawer.open();
        }, 100);
        
      } catch (error) {
        console.error('Error adding to cart:', error);
        alert('Error adding to cart. Please try again.');
      } finally {
        if (originalText) originalText.style.opacity = '1';
        button.style.pointerEvents = 'auto';
        button.disabled = false;
      }
    });
  });

  // ─── Remove box from cart (event delegation — works after cart re-render) ──
  document.addEventListener('click', async function(e) {
    const removeBtn = e.target.closest('[data-remove-box]');
    if (!removeBtn) return;

    removeBtn.disabled = true;
    removeBtn.style.opacity = '0.5';

    const keys = removeBtn.getAttribute('data-remove-box').split(',').filter(Boolean);

    const updates = {};
    keys.forEach(key => { updates[key] = 0; });

    try {
      const response = await fetch((window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update') + '.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ updates })
      });

      if (!response.ok) {
        console.error('Error removing box from cart');
        return;
      }

      await refreshCartUI();

    } catch (error) {
      console.error('Error removing box:', error);
    } finally {
      if (removeBtn) {
        removeBtn.disabled = false;
        removeBtn.style.opacity = '1';
      }
    }
  });

  // ─── Box quantity +/− (event delegation — works after cart re-render) ──────
  document.addEventListener('click', async function(e) {
    const minusBtn = e.target.closest('[data-box-minus]');
    const plusBtn = e.target.closest('[data-box-plus]');
    const btn = minusBtn || plusBtn;
    if (!btn) return;
    if (btn.closest('cart-drawer')) return; // handled by cart-drawer-custom.js

    btn.disabled = true;

    const keys = btn.getAttribute('data-box-keys').split(',').filter(Boolean);
    const baseQtys = btn.getAttribute('data-box-base-qtys').split(',').map(q => parseInt(q, 10) || 1);

    const display = btn.closest('.quantity').querySelector('.box-quantity-display');
    const currentCount = parseInt(display.textContent, 10) || 1;
    const newCount = minusBtn ? currentCount - 1 : currentCount + 1;

    if (newCount < 0) {
      btn.disabled = false;
      return;
    }

    const updates = {};
    keys.forEach((key, i) => {
      updates[key] = newCount * (baseQtys[i] || 1);
    });

    // When removing the box entirely, also remove its linked offer item
    if (newCount === 0) {
      const boxGroup = btn.getAttribute('data-box-group');
      if (boxGroup) {
        try {
          const cartRes = await fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', { credentials: 'same-origin' });
          const cart = await cartRes.json();
          cart.items.forEach(item => {
            if (item.properties && item.properties['_offer_for'] === boxGroup) {
              updates[item.key] = 0;
            }
          });
        } catch (err) {
          console.error('Error fetching cart for offer removal:', err);
        }
      }
    }

    try {
      const response = await fetch((window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ updates })
      });

      if (!response.ok) {
        console.error('Error updating box quantity');
        return;
      }

      await refreshCartUI();

    } catch (error) {
      console.error('Error updating box quantity:', error);
    } finally {
      if (btn) btn.disabled = false;
    }
  });

  // Countdown timers
  document.querySelectorAll('[data-countdown-end]').forEach(el => {
    const endTime = new Date(el.dataset.countdownEnd).getTime();
    if (isNaN(endTime)) return;

    const days = el.querySelector('[data-unit="days"]');
    const hours = el.querySelector('[data-unit="hours"]');
    const minutes = el.querySelector('[data-unit="minutes"]');
    const seconds = el.querySelector('[data-unit="seconds"]');

    function pad(n) { return String(n).padStart(2, '0'); }

    if (Date.now() >= endTime) {
      el.style.display = 'none';
      return;
    }

    function tick() {
      const diff = endTime - Date.now();
      if (diff <= 0) {
        el.style.display = 'none';
        return;
      }
      const totalSeconds = Math.floor(diff / 1000);
      if (days) days.textContent = pad(Math.floor(totalSeconds / 86400));
      hours.textContent = pad(Math.floor((totalSeconds % 86400) / 3600));
      minutes.textContent = pad(Math.floor((totalSeconds % 3600) / 60));
      seconds.textContent = pad(totalSeconds % 60);
    }

    tick();
    setInterval(tick, 1000);
  });
});
